module.exports = __webpack_public_path__ + "static/media/cooperation-min.c5ac25e9.jpg";